import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { connect } from 'react-redux';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { searchBuyers } from "../actions/buyersActions";
import BuyerSearch from './BuyerSearch';

const styles = {
  dialogPaper: {
    minHeight: '80vh',
    maxHeight: '80vh',
    maxWidth: '60vw',
    minWidth: '60vw'
  }
};

class NewBuyerDialog extends Component {

  constructor(props) {
    super(props);
    this.buyers = props.buyers;
  }

  state = {
    query: '',
    selected: 0
  };

  handleKeyDown = (evt) => {
    switch (evt.which) {
      case 13:
        this.select(evt);
        break;
      case 38:
        this.moveUp(evt);
        break;
      case 40:
        this.moveDown(evt);
        break;
      default:
    }
  };

  getCount = () => {
    const { results } = this.props;
    const { query } = this.state;
    return !!results ? results[query].length : 0;
  };

  moveDown = (evt) => {
    evt.preventDefault();
    const { selected } = this.state;
    if (selected < this.getCount() - 1) {
      this.setState({ selected: selected + 1 });
    }
  };

  moveUp = (evt) => {
    evt.preventDefault();
    const { selected } = this.state;
    if (selected > 0) {
      this.setState({ selected: selected - 1 });
    }
  };

  select = (evt) => {
    evt.preventDefault();
    const { selected, query } = this.state;
    const { results } = this.props;
    let target = 'no buyer';
    if (results && results[query]) {
      target = results[query][selected];
    }
    this.props.onSelect(target);
    this.props.onClose(target);
  };

  selectWithClick = (item) => () => {
    this.props.onSelect(item);
    this.props.onClose(item);
  };

  closeResults = () => {
    this.handleChange({ target: { value: '' } });
  };

  handleChange = (evt) => {
    const { dispatch, results } = this.props;
    const cache = !!results ? new Map(Object.entries(results)) : new Map();
    const val = evt.target.value;
    if (val.length >= 3 && !cache.has(val)) {
      dispatch(searchBuyers(val));
    }
    this.setState({ query: val, selected: 0 });
  };

  handleClose = () => {
    this.props.onClose(false);
  };

  handleCancel = value => {
    this.props.onClose();
  };

  render() {
    const { classes, onClose, orderType, message, buyerExists, results, ...other } = this.props;
    const { query, selected } = this.state;

    return (
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        onClose={this.handleClose}
        aria-labelledby="simple-dialog-title"
        {...other}
      >
        <DialogTitle id="simple-dialog-title">Select Programmatic Buyer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
          <ClickAwayListener onClickAway={this.closeResults}>
            <BuyerSearch
              query={query}
              results={results}
              selected={selected}
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              onClose={this.closeResults}
              onSelect={this.selectWithClick}
            />
          </ClickAwayListener>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.handleCancel()} color="secondary">Cancel</Button>
        </DialogActions>
      </Dialog>
    )
  }
}

NewBuyerDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  buyerExists: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired
};


const mapStateToProps = state => {
  const { buyersSearchRequest } = state;
  return {
    results: buyersSearchRequest.results
  }
};

export default withStyles(styles)(connect(mapStateToProps)(NewBuyerDialog));
